"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadImg = uploadImg;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
var BASE = '/xyZdyDragging';

/**
 * 装修内通用图片上传
 * @param {FormData} formData  必须包含字段名 file
 */
function uploadImg(formData) {
  return (0, _requestAuth.default)({
    url: BASE + '/uploadPic',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}